export class SDNameFormat {
    formatName: string;
    tableName: string;
    columnName: string;
    prefix: string;
    suffix: string;
    counter: number;
    isActive: boolean;
}
